import { orderTemplate } from '@/dataStructures';

const orderTemplateTemplate = orderTemplate();

function setOrderTemplates(state, templates) {
	state.orderTemplates = templates;
}

function setTemplateToEdit(state, templateDetails) {
	for (let key in state.templateDetails) {
		state.templateDetails[key] = templateDetails[key] === undefined ? undefined : JSON.parse(JSON.stringify(templateDetails[key]));
	}
}

function updateTemplateDetails(state, { key, value }) {
	state.templateDetails[key] = value;

	// set goodsTypeId or customerId
	if (`${key}Id` in orderTemplateTemplate) {
		state.templateDetails[`${key}Id`] = value.id;
	}
}

function setGeneratedOrders(state, orders) {
	state.generatedOrders = orders;
}

function resetDetails(state) {
	state.templateDetails = orderTemplate();
}

function setLoading(state, loading) {
	state.loading = loading;
}

function setFreightLinesValue(state, { lineNo, key, value }) {
	let newFreightLines = state.templateDetails.freightLines.slice();
	let freightLine = newFreightLines.find(line => line.lineNo === lineNo);
	freightLine[key] = value;

	if (key === 'length' || key === 'width' || key === 'height')
		freightLine.volume = freightLine.length * freightLine.width * freightLine.height;

	if (key === 'numberOfUnits') {
		let quantity = 0;
		for (let line of newFreightLines) {
			quantity += line.numberOfUnits;
		}
		state.templateDetails.numberOfPackages = quantity;
	}
	state.templateDetails.freightLines = newFreightLines;
}

function addFreightLine(state, freightLine) {
	let newFreightLines = state.templateDetails.freightLines.slice();
	newFreightLines.push(freightLine);
	state.templateDetails.freightLines = newFreightLines;
}

function deleteFreightLine(state, lineNo) {
	let newFreightLines = state.templateDetails.freightLines.slice();
	let index = newFreightLines.indexOf( newFreightLines.find( line => line.lineNo === lineNo ) );
	newFreightLines.splice( index, 1 );

	let quantity = 0;
	newFreightLines.forEach((line, index) => {
		line.lineNo = index + 1;
		quantity += line.numberOfUnits;
	});

	state.templateDetails.numberOfPackages = quantity;
	state.templateDetails.freightLines = newFreightLines;
}

function setFreeText(state, { key, freeText }) {
	state.templateDetails[key] = freeText;
}

export default {
	setOrderTemplates,
	setTemplateToEdit,
	updateTemplateDetails,
	setGeneratedOrders,
	resetDetails,
	setLoading,
	setFreightLinesValue,
	addFreightLine,
	deleteFreightLine,
	setFreeText
};